export default __webpack_public_path__ + "static/media/vingtun.2b47b375.jpg";